export const getDefaultPromotion = (offerId: string, defaultPromotions?: Record<string, string>): string | undefined => {
  return defaultPromotions?.[offerId];
};
